import { useEffect } from 'react'
import { ThemeProvider } from '@styled'
import { theme } from '@styled/theme'
import '@assets/css/fonts.css'
import 'bootstrap/dist/css/bootstrap.min.css'
import { GlobalStyle } from '@assets/css/main-style'
import ScrollToTop from '@ui/scroll-to-top'
import Transition from '@components/transition'
import '@fortawesome/fontawesome-svg-core/styles.css'
import { config } from '@fortawesome/fontawesome-svg-core'
import './style.css'

config.autoAddCss = false

const saAutoEventsScriptURL =
  'https://scripts.simpleanalyticscdn.com/auto-events.js'
let saAutoEventsScript = null

const Layout = ({ children, location }) => {
  useEffect(() => {
    const appendEventsScript = (content) => {
      const script = document.createElement('script')
      script.textContent = content
      document.head.appendChild(script)
      return () => {
        document.head.removeChild(script)
      }
    }
    const loadEventsScript = async () => {
      if (saAutoEventsScript) {
        appendEventsScript(saAutoEventsScript)
      } else {
        try {
          const response = await fetch(saAutoEventsScriptURL)
          if (!response.ok)
            throw new Error(`Failed to fetch script: ${response.statusText}`)
          saAutoEventsScript = await response.text()
          saAutoEventsScript = saAutoEventsScript.replace(
            '//# sourceMappingURL=auto-events.js.map',
            `//# sourceMappingURL=${saAutoEventsScriptURL}.map`
          )
          appendEventsScript(saAutoEventsScript)
        } catch (error) {
          console.error('Error fetching the script:', error)
        }
      }
    }
    loadEventsScript()
  }, [location.pathname])

  return (
    <ThemeProvider theme={theme}>
      <Transition location={location}>
        <div className="wrapper">
          <GlobalStyle />
          {children}
          <ScrollToTop />
        </div>
      </Transition>
    </ThemeProvider>
  )
}

export default Layout
